<template>
  <Modal
    v-model="_value"
    width="600"
    title="查看/修改定位设备信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="height: 730px;border: 1px solid #dcdee2;">
      <Split v-model="split1">
        <div slot="left" class="demo-split-pane">
    <Form ref="loginForm" :model="positioningDeviceInfo" :rules="rules" style="display: inline;">
      <FormItem prop="terminalNum">
        <label style="display: inline-block; width: 60px;">主机号</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="positioningDeviceInfo.terminalNum" placeholder="请输入主机号">
        </Input>
      </FormItem>
      <div v-for="item in positioningDeviceInfo.simInfos">
        <FormItem prop="simInfos">
          <label style="display: inline-block; width: 60px;">真实SIM码</label>
          <Input style="display: inline-block; width: 200px;" disabled v-model="item.simNum + '(' + item.remark + ')'" placeholder="请输入真实SIM码">
          </Input>
        </FormItem>
      </div>
      <FormItem prop="factoryTerminalNum">
        <label style="display: inline-block; width: 60px;">出厂主机号</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="positioningDeviceInfo.factoryTerminalNum" placeholder="请输入出厂主机号">
        </Input>
      </FormItem>
      <FormItem prop="firmware">
        <label style="display: inline-block; width: 60px;">固件版本号</label>
        <Input style="display: inline-block; width: 200px;" type="textarea" :disabled="!modify" v-model="positioningDeviceInfo.firmware" placeholder="请输入固件版本号">
        </Input>
      </FormItem>
      <FormItem prop="setupDatetime">
        <label style="display: inline-block; width: 60px;">安装时间</label>
        <DatePicker :disabled="!modify" style="display: inline-block; width: 200px;" type="date" v-model="positioningDeviceInfo.setupDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="serviceDatetime">
        <label style="display: inline-block; width: 60px;">服务到费期</label>
        <DatePicker style="display: inline-block; width: 200px;" :disabled="true" type="date" v-model="positioningDeviceInfo.serviceDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="videoServiceDatetime">
        <label style="display: inline-block; width: 60px;">视频到费期</label>
        <DatePicker style="display: inline-block; width: 200px;" :disabled="true" type="date" v-model="positioningDeviceInfo.videoServiceDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="positioningDeviceModelId">
        <label style="display: inline-block; width: 60px;">设备型号</label>
        <Select :disabled="!modify" placeholder="选择设备型号" style="display: inline-block; width: 200px;"
                v-model="positioningDeviceInfo.positioningDeviceModelId"
                @on-change="selectPositioningDeviceInfoaisle"
        >
          <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="sourceType">
        <label style="display: inline-block; width: 60px;">设备来源</label>
        <Select :disabled="!modify" placeholder="选择设备来源" style="display: inline-block; width: 200px;"
                v-model="positioningDeviceInfo.sourceType"
        >
          <Option v-for="(option, index) in positioningDeviceSourceTypeOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="serviceState">
        <label style="display: inline-block; width: 60px;">服务状态</label>
        <Select :disabled="!modify" placeholder="选择服务状态" style="display: inline-block; width: 200px;"
                v-model="positioningDeviceInfo.serviceState"
        >
          <Option v-for="(option, index) in positioningDeviceServiceStateOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="encryptionChipNumber">
        <label style="display: inline-block; width: 60px;">加密芯片号</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="positioningDeviceInfo.encryptionChipNumber" placeholder="请输入加密芯片号">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <label style="display: inline-block; width: 60px;">备注</label>
        <Input style="display: inline-block; width: 200px;" type="textarea" :disabled="!modify" v-model="positioningDeviceInfo.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
    </Form>
        </div>
        <div slot="right" class="demo-split-pane">
          <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
            <Checkbox  :disabled="!modify"
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll">全选</Checkbox>
          </div>
          <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
            <Checkbox label="摄像头通道-1" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleOne"></Checkbox><br>
            <Checkbox label="摄像头通道-2" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleTwo"></Checkbox><br>
            <Checkbox label="摄像头通道-3" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleThree"></Checkbox><br>
            <Checkbox label="摄像头通道-4" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleFour"></Checkbox><br>
            <Checkbox label="摄像头通道-5" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleFive"></Checkbox><br>
            <Checkbox label="摄像头通道-6" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleSix"></Checkbox><br>
            <Checkbox label="摄像头通道-7" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleSeven"></Checkbox><br>
            <Checkbox label="摄像头通道-8" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleEight"></Checkbox><br>
            <Checkbox label="摄像头通道-9" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleNine"></Checkbox><br>
            <Checkbox label="摄像头通道-10" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleTen"></Checkbox><br>
          </CheckboxGroup>

        </div>
      </Split>
    </div>
    <Row style="text-align: right;">
      <Button size="small" style="margin-right: 3px;" @click="onPositioningDeviceFittingsDetailModal" type="primary">设备配件</Button>
      <Button size="small" style="margin-right: 3px;" @click="onModifyPositioningDeviceServiceDatetime" type="primary">修改到费期</Button>
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
    <positioning-device-fittings-detail-modal v-model="PositioningDeviceFittingsDetailModal" :initValue="PositioningDeviceFittingsDetailModalId" @on-success="onSuccess"></positioning-device-fittings-detail-modal>
    <add-positioning-device-fittings-modal  v-model="AddPositioningDeviceFittingsModal" :initValue="AddPositioningDeviceFittingsModalId" :terminalNumValue="AddPositioningDeviceFittingsModalterminalNum" @on-positioningdevicefittings="onPositioningdevicefittings"></add-positioning-device-fittings-modal>
    <modify-positioning-device-service-datetime-modal v-model="modifyPositioningDeviceServiceDatetimeModal" :initValue="modifyPositioningDeviceServiceDatetimeId" @on-success="onSuccess"></modify-positioning-device-service-datetime-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import ModifyPositioningDeviceServiceDatetimeModal from '@/view/im/components/modify-positioning-device-service-datetime-modal'
import AddPositioningDeviceFittingsModal from '@/view/im/components/add-positioning-device-fittings-modal'
import PositioningDeviceFittingsDetailModal from '../positioning-device-fittings-detail-modal/positioning-device-fittings-detail-modal'

export default {
  name: 'PositioningDeviceInfoDetailModal',
  components: {
    PositioningDeviceFittingsDetailModal,
    ModifyPositioningDeviceServiceDatetimeModal,
    AddPositioningDeviceFittingsModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    terminalNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: 'SIM卡号码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // 多选
      indeterminate: false,
      checkAll: false,
      checkAllGroup: [],

      // 分割面板
      split1: 0.5,

      // 查看/修改设备配件
      PositioningDeviceFittingsDetailModal: false,
      PositioningDeviceFittingsDetailModalId: null,
      // 添加设备配件
      AddPositioningDeviceFittingsModal: false,
      AddPositioningDeviceFittingsModalId: null,
      AddPositioningDeviceFittingsModalterminalNum: null,

      // 修改服务到费期
      modifyPositioningDeviceServiceDatetimeModal: false,
      modifyPositioningDeviceServiceDatetimeId: null,

      modify: false,
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      positioningDeviceModelOptions: [
        { label: 'BSJ-A6-BD', value: 1 },
        { label: 'BSJ-GF03', value: 2 },
        { label: 'BSJ-M11', value: 3 },
        { label: 'BSJ-A6L', value: 13 },
        { label: 'BSJ-A7', value: 14 },
        { label: 'K5', value: 4 },
        { label: 'D5X', value: 5 },
        { label: 'G-3G', value: 6 },
        { label: 'D5X-HDD', value: 7 },
        { label: 'D5X-XR', value: 8 },
        { label: 'BSJ-GF06', value: 9 },
        { label: 'BSJ-RM01', value: 10 },
        { label: 'HIK-A3', value: 11 },
        { label: 'HIK-A3L', value: 12 }
      ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceServiceStateOptions: [
        { label: '停止服务', value: 0 },
        { label: '服务中', value: 1 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModelId: null,
        sourceType: null,
        serviceState: null,
        firmware: null,
        encryptionChipNumber: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null,
        videoServiceDatetime: null,
        aisleOne: null,
        aisleTwo: null,
        aisleThree: null,
        aisleFour: null,
        aisleFive: null,
        aisleSix: null,
        aisleSeven: null,
        aisleEight: null,
        aisleNine: null,
        aisleTen: null,
        simInfos:[]
      }
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj'
    ]),
    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false

      if (this.checkAll) {
        this.checkAllGroup = ['摄像头通道-1', '摄像头通道-2', '摄像头通道-3', '摄像头通道-4', '摄像头通道-5', '摄像头通道-6', '摄像头通道-7', '摄像头通道-8', '摄像头通道-9', '摄像头通道-10']
        this.positioningDeviceInfo.aisleOne = true
        this.positioningDeviceInfo.aisleTwo = true
        this.positioningDeviceInfo.aisleThree = true
        this.positioningDeviceInfo.aisleFour = true
        this.positioningDeviceInfo.aisleFive = true
        this.positioningDeviceInfo.aisleSix = true
        this.positioningDeviceInfo.aisleSeven = true
        this.positioningDeviceInfo.aisleEight = true
        this.positioningDeviceInfo.aisleNine = true
        this.positioningDeviceInfo.aisleTen = true
      } else {
        this.checkAllGroup = []
        this.positioningDeviceInfo.aisleOne = false
        this.positioningDeviceInfo.aisleTwo = false
        this.positioningDeviceInfo.aisleThree = false
        this.positioningDeviceInfo.aisleFour = false
        this.positioningDeviceInfo.aisleFive = false
        this.positioningDeviceInfo.aisleSix = false
        this.positioningDeviceInfo.aisleSeven = false
        this.positioningDeviceInfo.aisleEight = false
        this.positioningDeviceInfo.aisleNine = false
        this.positioningDeviceInfo.aisleTen = false
      }
    },
    checkAllGroupChange (data) {
      if (data.length === 10) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
      //
      // data.forEach(item =>{
      //   console.log(item)
      //   if (item == '摄像头通道-1') {
      //     this.positioningDeviceInfo.aisleOne = true
      //   }else if (item == '摄像头通道-2') {
      //     this.positioningDeviceInfo.aisleTwo = true
      //   }else if (item == '摄像头通道-3') {
      //     this.positioningDeviceInfo.aisleThree = true
      //   }
      // })
    },

    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改定位设备信息',
          content: '<p>确认修改定位设备信息</p>',
          onOk: () => {
            if (this.positioningDeviceInfo.setupDatetime) {
              this.positioningDeviceInfo.setupDatetime = new Date(this.positioningDeviceInfo.setupDatetime)
            }
            store.dispatch('PositioningDeviceInfoServ_ModifyObj', {
              params: this.positioningDeviceInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            let positioningDeviceInfoId = this._initValue
            store.dispatch('PositioningDeviceInfoServ_GetDetail', {
              params: { id: positioningDeviceInfoId }
            }).then(() => {
              this.positioningDeviceInfo = store.getters.get_PositioningDeviceInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    onSuccess () {
      this.visibleChange(true)
    },
    onPositioningdevicefittings () {
      let queryParams = []
      queryParams.push(genQueryParam('terminalNum', 'EQ', this.positioningDeviceInfo.terminalNum))
      store.dispatch('PositioningDeviceFittingsServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams
        }
      }).then(() => {
        console.log(store.getters.get_PositioningDeviceFittings_GetAllResult)
        this.positioningDeviceInfo.positioningDeviceFittingsId = store.getters.get_PositioningDeviceFittings_GetAllResult[0].id
        store.dispatch('PositioningDeviceInfoServ_BindPositioningDeviceFittings', {
          params: {
            id: this.positioningDeviceInfo.id,
            positioningdevicefittingsid: this.positioningDeviceInfo.positioningDeviceFittingsId
          },
          urlparams: null
        }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onPositioningDeviceFittingsDetailModal () {
      console.log('ok')
      if (this.positioningDeviceInfo.positioningDeviceFittingsId == null) {
        this.AddPositioningDeviceFittingsModalId = this.positioningDeviceInfo.installOrderId
        this.AddPositioningDeviceFittingsModal = true
        this.AddPositioningDeviceFittingsModalterminalNum = this.positioningDeviceInfo.terminalNum
      } else {
        this.PositioningDeviceFittingsDetailModalId = this.positioningDeviceInfo.positioningDeviceFittingsId
        this.PositioningDeviceFittingsDetailModal = true
      }
    },
    onModifyPositioningDeviceServiceDatetime () {
      console.log('ok')
      this.modifyPositioningDeviceServiceDatetimeId = this._initValue
      this.modifyPositioningDeviceServiceDatetimeModal = true
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.positioningDeviceInfo.id = null
        this.positioningDeviceInfo.terminalNum = null
        this.positioningDeviceInfo.factoryTerminalNum = null
        this.positioningDeviceInfo.positioningDeviceModelId = null
        this.positioningDeviceInfo.sourceType = null
        this.positioningDeviceInfo.serviceState = null
        this.positioningDeviceInfo.firmware = null
        this.positioningDeviceInfo.encryptionChipNumber = null
        this.positioningDeviceInfo.remark = null
        this.positioningDeviceInfo.setupDatetime = null
        this.positioningDeviceInfo.serviceDatetime = null
        this.positioningDeviceInfo.videoServiceDatetime = null
        this.positioningDeviceInfo.aisleOne = false
        this.positioningDeviceInfo.aisleTwo = false
        this.positioningDeviceInfo.aisleThree = false
        this.positioningDeviceInfo.aisleFour = false
        this.positioningDeviceInfo.aisleFive = false
        this.positioningDeviceInfo.aisleSix = false
        this.positioningDeviceInfo.aisleSeven = false
        this.positioningDeviceInfo.aisleEight = false
        this.positioningDeviceInfo.aisleNine = false
        this.positioningDeviceInfo.aisleTen = false
        this.checkAllGroup = []
        let positioningDeviceInfoId = this._initValue
        if (positioningDeviceInfoId) {
          store.dispatch('PositioningDeviceInfoServ_GetDetail', {
            params: { id: positioningDeviceInfoId }
          }).then(() => {
            this.positioningDeviceInfo = store.getters.get_PositioningDeviceInfo_GetDetailResult
            if (this.positioningDeviceInfo.setupDatetime) {
              this.positioningDeviceInfo.setupDatetime = new Date(this.positioningDeviceInfo.setupDatetime)
            }
            if (this.positioningDeviceInfo.serviceDatetime) {
              this.positioningDeviceInfo.serviceDatetime = new Date(this.positioningDeviceInfo.serviceDatetime)
            }
            if (this.positioningDeviceInfo.videoServiceDatetime) {
              this.positioningDeviceInfo.videoServiceDatetime = new Date(this.positioningDeviceInfo.videoServiceDatetime)
            }
            if (this.positioningDeviceInfo.aisleOne) {
              this.checkAllGroup.push('摄像头通道-1')
            } else {
              this.positioningDeviceInfo.aisleOne = false
            }
            if (this.positioningDeviceInfo.aisleTwo) {
              this.checkAllGroup.push('摄像头通道-2')
            } else {
              this.positioningDeviceInfo.aisleTwo = false
            }
            if (this.positioningDeviceInfo.aisleThree) {
              this.checkAllGroup.push('摄像头通道-3')
            } else {
              this.positioningDeviceInfo.aisleThree = false
            }
            if (this.positioningDeviceInfo.aisleFour) {
              this.checkAllGroup.push('摄像头通道-4')
            } else {
              this.positioningDeviceInfo.aisleFour = false
            }
            if (this.positioningDeviceInfo.aisleFive) {
              this.checkAllGroup.push('摄像头通道-5')
            } else {
              this.positioningDeviceInfo.aisleFive = false
            }
            if (this.positioningDeviceInfo.aisleSix) {
              this.checkAllGroup.push('摄像头通道-6')
            } else {
              this.positioningDeviceInfo.aisleSix = false
            }
            if (this.positioningDeviceInfo.aisleSeven) {
              this.checkAllGroup.push('摄像头通道-7')
            } else {
              this.positioningDeviceInfo.aisleSeven = false
            }
            if (this.positioningDeviceInfo.aisleEight) {
              this.checkAllGroup.push('摄像头通道-8')
            } else {
              this.positioningDeviceInfo.aisleEight = false
            }
            if (this.positioningDeviceInfo.aisleNine) {
              this.checkAllGroup.push('摄像头通道-9')
            } else {
              this.positioningDeviceInfo.aisleNine = false
            }
            if (this.positioningDeviceInfo.aisleTen) {
              this.checkAllGroup.push('摄像头通道-10')
            } else {
              this.positioningDeviceInfo.aisleTen = false
            }
          }).catch(err => {
            this.$Message.error(err)
          })
        }
        store.dispatch('PositioningDeviceTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          this.positioningDeviceModelOptions = store.getters.get_PositioningDeviceType_GetAllResult
        }).catch(err => {
          console.log(err)
        })
      }
    },
    selectPositioningDeviceInfoaisle (data) {
      console.log(data)
      if (data) {
        /**
         * 根据选择类型，默认匹配摄像头搭配
         */
        store.dispatch('PositioningDeviceTypeServ_GetDetail', {
          params: {
            id: data
          },
          urlparams: null
        }).then(res => {
          console.log(res)
          if (store.getters.get_PositioningDeviceType_GetDetailResult.adas) {
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '杭州海康汽车技术有限公司') {
              this.positioningDeviceInfo.aisleOne = true
              this.positioningDeviceInfo.aisleTwo = true
              this.positioningDeviceInfo.aisleThree = false
              this.positioningDeviceInfo.aisleFour = true
              this.positioningDeviceInfo.aisleFive = false
              this.positioningDeviceInfo.aisleSix = false
              this.positioningDeviceInfo.aisleSeven = false
              this.positioningDeviceInfo.aisleEight = false
              this.positioningDeviceInfo.aisleNine = false
              this.positioningDeviceInfo.aisleTen = false
            }
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '深圳市锐明技术股份有限公司') {
              if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername == 'D5X') {
                this.positioningDeviceInfo.aisleOne = false
                this.positioningDeviceInfo.aisleTwo = false
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = true
                this.positioningDeviceInfo.aisleSix = true
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              } else if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername == 'D5X_HDD') {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = true
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = true
                this.positioningDeviceInfo.aisleTen = true
              } else if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername = ('D5X_XR')) {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = true
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = true
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              }
            }
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '江苏中天安驰科技有限公司') {
              this.positioningDeviceInfo.aisleOne = true
              this.positioningDeviceInfo.aisleTwo = true
              this.positioningDeviceInfo.aisleThree = true
              this.positioningDeviceInfo.aisleFour = false
              this.positioningDeviceInfo.aisleFive = false
              this.positioningDeviceInfo.aisleSix = false
              this.positioningDeviceInfo.aisleSeven = false
              this.positioningDeviceInfo.aisleEight = false
              this.positioningDeviceInfo.aisleNine = false
              this.positioningDeviceInfo.aisleTen = false
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        terminalNum: this.terminalNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
<style>
  .demo-split{
    height: 600px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }

  .Checkbox{
    padding: 10px;
  }
</style>
